import React from "react";
import { Heading, Text, Box, Image } from "rebass";
import styled from "styled-components";
import Img from "react-image";

import Button from "../../components/ui/Button";
import Circle from "../../components/ui/Circle";
import automateIcon from "../../img/automate-icon.svg";
import MessengerBubble from "../../components/ui/MessengerBubble";
import ads from "../../img/avatars/ads.jpg";
import giles from "../../img/avatars/giles.jpg";
import gaz from "../../img/avatars/gaz.jpg";
import bjorn from "../../img/avatars/bjorn.jpg";
// import jess from "../../img/avatars/jess.jpg";
import jose from "../../img/avatars/jose.jpg";
import sarah from "../../img/avatars/sarah.jpg";
import sue from "../../img/avatars/sue.jpg";

type Props = {
  siteMetadata: { appUrl: string }
};

const { Fragment } = React;

const IntroPart3 = (props: Props) => (
  <Fragment>
    <Box w={[1]} mb={["225px"]} pb={[6]} className="relative">
      <Box
        w={[1, 1, "432px"]}
        mx={[0, 0, "auto"]}
        mt={[0, 0, "100px"]}
        className="relative"
      >
        <StyledHeading
          color="support2"
          className="font-light relative"
          is="h4"
          f={[3, 4, "26px"]}
          mb={[3]}
        >
          <AutomateIcon src={automateIcon} alt="Automate icon" is={Img} />
          Automate your sales
        </StyledHeading>
        <Text color="support1" f="15px" mb={[4]}>
          Harness the power of our automated marketing platform by sending
          personalized messages and responses.
        </Text>
        <Button is="a" href={props.siteMetadata.appUrl}>
          GET STARTED FOR FREE
        </Button>
      </Box>

      <Section3Circle1 r={4} />
      <Section3Circle2 r={5.5} />
      <Section3Circle3 r={8} />
      <Section3Circle4 r={13} />
      <Section3Circle5 r={23} />
      <Section3Circle6 r={9.5} />
      <Section3Circle7 r={4.5} />

      <StyledMessengerBubble1>
        <MessengerBubble message="Hey Adam" src={ads} />
      </StyledMessengerBubble1>

      <StyledMessengerBubble2>
        <MessengerBubble message="Hello Giles" src={giles} />
      </StyledMessengerBubble2>

      <StyledMessengerBubble3>
        <MessengerBubble message="Hi Sarah" src={sarah} />
      </StyledMessengerBubble3>

      <StyledMessengerBubble4>
        <MessengerBubble message="Hola Jose" src={jose} />
      </StyledMessengerBubble4>

      <StyledMessengerBubble5>
        <MessengerBubble message="Hei Björn" src={bjorn} />
      </StyledMessengerBubble5>

      <StyledMessengerBubble6>
        <MessengerBubble message="Hey Gaz" src={gaz} />
      </StyledMessengerBubble6>

      <StyledMessengerBubble7>
        <MessengerBubble message="Howdy Sue" src={sue} />
      </StyledMessengerBubble7>
    </Box>
  </Fragment>
);

export default IntroPart3;

// Styled Components
const AutomateIcon = styled(Image)`
  right: -73px;
  margin: 0;
  position: absolute;
  top: -54px;
  transform: scale(0.8);

  @media (min-width: 48em) {
    right: auto;
    left: -38px;
    top: -94px;
    transform: scale(1);
  }
`;

const StyledHeading = styled(Heading)`
  display: inline-block;
`;

const StyledMessengerBubble1 = styled.div`
  bottom: -86px;
  position: absolute;
  left: 5%;
  transform: rotate(5deg);

  @media (min-width: 48em) {
    bottom: auto;
    left: 30px;
    top: -120px;
    transform: rotate(-5deg);
  }

  @media (min-width: 72em) {
    top: -180px;
  }
`;

const StyledMessengerBubble2 = styled.div`
  bottom: 20px;
  position: absolute;
  right: 20%;
  transform: rotate(-5deg);

  @media (min-width: 48em) {
    bottom: auto;
    left: 310px;
    top: -80px;
    transform: rotate(4deg);
  }
`;

const StyledMessengerBubble3 = styled.div`
  display: none;
  position: absolute;

  @media (min-width: 56em) {
    display: block;
    bottom: auto;
    left: 0;
    top: 170px;
    transform: rotate(-4deg);
  }

  @media (min-width: 72em) {
    left: 90px;
    top: 70px;
  }
`;

const StyledMessengerBubble4 = styled.div`
  display: none;
  position: absolute;

  @media (min-width: 48em) {
    display: block;
    bottom: auto;
    left: 70%;
    top: 20px;
    transform: rotate(3deg);
  }

  @media (min-width: 72em) {
    left: 610px;
    top: 0px;
  }
`;

const StyledMessengerBubble5 = styled.div`
  display: none;
  position: absolute;

  @media (min-width: 72em) {
    display: block;
    bottom: auto;
    left: 890px;
    top: 150px;
    transform: rotate(2deg);
  }
`;

const StyledMessengerBubble6 = styled.div`
  left: 20px;
  position: absolute;
  top: -100px;
  transform: rotate(3deg);

  @media (min-width: 48em) {
    display: block;
    left: 190px;
    top: 330px;
    transform: rotate(1deg);
  }
  @media (min-width: 72em) {
    top: 280px;
  }
`;

const StyledMessengerBubble7 = styled.div`
  display: none;
  position: absolute;

  @media (min-width: 48em) {
    display: block;
    bottom: auto;
    left: 60%;
    top: 230px;
    transform: rotate(-3deg);
  }

  @media (min-width: 72em) {
    left: 650px;
    top: 330px;
  }
`;

const Section3Circle1 = styled(Circle)`
  left: 0px;
  position: absolute;
  top: -60px;

  @media (min-width: 48em) {
    left: 70px;
    top: -240px;
  }
`;

const Section3Circle2 = styled(Circle)`
  left: 160px;
  position: absolute;
  top: 120px;

  @media (min-width: 48em) {
    left: 150px;
    top: -70px;
  }
`;

const Section3Circle3 = styled(Circle)`
  left: 30px;
  opacity: 0.3;
  position: absolute;
  top: 320px;

  @media (min-width: 48em) {
    left: 30px;
    top: 40px;
  }
`;

const Section3Circle4 = styled(Circle)`
  left: 280px;
  position: absolute;
  top: 310px;

  @media (min-width: 48em) {
    left: 90px;
    top: 300px;
  }
`;

const Section3Circle5 = styled(Circle)`
  left: 40px;
  position: absolute;
  top: 220px;

  @media (min-width: 48em) {
    left: 540px;
    top: 330px;
  }
`;

const Section3Circle6 = styled(Circle)`
  left: 100px;
  position: absolute;
  top: 400px;

  @media (min-width: 48em) {
    left: 900px;
    top: 80px;
  }
`;

const Section3Circle7 = styled(Circle)`
  left: 250px;
  position: absolute;
  top: 20px;

  @media (min-width: 48em) {
    left: 590px;
    top: -55px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/Intro/IntroPart3.jsx